"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.budgetOverspendTableName = void 0;
exports.budgetOverspendTableName = 'BudgetOverspend';
